<template>
  <div class="view-container">
    <div class="tabs-wrapper">
      <a-row justify="start" type="flex" :gutter="22">
        <a-col :span="6">
          <a-input-search
            placeholder="请输入关键字"
            @search="onSearch"
            @change="onSearch"
            size="default"
            v-model="keyword"
          />
        </a-col>
        <a-col>
          <a-popconfirm
            title="确定要删除吗 ?"
            @confirm="() => onDeleteInBatch()"
          >
            <a-icon slot="icon" type="question-circle-o" style="color: red" />
            <a-button type="default"><a-icon type="delete" />删除选中</a-button>
          </a-popconfirm>
        </a-col>
      </a-row>
      <a-row style="margin-top: 10px">
        <a-table
          :columns="columns"
          :rowKey="record => record.id"
          :dataSource="tableData"
          :bordered="true"
          :rowClassName="tableRowClass"
          :rowSelection="rowSelection"
          :pagination="pagination"
          @change="paginationChange"
        >
          <template slot="cell" slot-scope="text">
            <span
              v-html="formatContent(text, keyword)"
              class="cell-text"
            ></span>
          </template>
          <template slot="operation" slot-scope="text, record">
            <a-popconfirm
              v-if="tableData.length"
              title="确定删除吗 ?"
              @confirm="() => onDelete(record.id)"
            >
              <a href="javascript:;"> <a-icon type="delete" />删除 </a>
            </a-popconfirm>
          </template>
        </a-table>
      </a-row>
    </div>
  </div>
</template>

<script>
import { getCooperation, deleteCooperation } from '@/api/cooperation'
import moment from 'moment'
export default {
  data() {
    return {
      columns: [],
      tableData: [],
      rowKeys: [],
      rowSelection: {
        onChange: selectedRowKeys => {
          this.rowKeys = selectedRowKeys
        }
      },
      pagination: {
        showSizeChanger: true,
        defaultCurrent: 1,
        defaultPageSize: 10,
        showTotal: total => {
          return `共 ${total} 条数据`
        }
      },
      keyword: ''
    }
  },
  created() {
    this.columns = [
      {
        title: '姓名',
        dataIndex: 'name',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '手机号',
        dataIndex: 'phone',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '邮箱',
        dataIndex: 'email',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '职位',
        dataIndex: 'position',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '公司名称',
        dataIndex: 'company',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '公司地址',
        dataIndex: 'companyAddress',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '拟投入RPA销售人员数量',
        dataIndex: 'salesmanCount',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '拟投入RPA技术人员数量',
        dataIndex: 'technicianCount',
        scopedSlots: { customRender: 'cell' }
      },
      {
        title: '创建时间',
        dataIndex: 'createdAt',
        scopedSlots: { customRender: 'cell' },
        customRender: text => {
          return moment(text).format('YYYY-MM-DD HH:mm:ss')
        }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' }
      }
    ]
    this.fetchData()
  },
  methods: {
    fetchData() {
      let { keyword, pagination } = this
      keyword = keyword.trim()
      const page = pagination.current || pagination.defaultCurrent
      const size = pagination.size || pagination.defaultPageSize
      getCooperation({ keyword, page, size }).then(resp => {
        let { result: res } = resp
        this.tableData = res.rows
        pagination.total = res.total
        this.pagination = JSON.parse(JSON.stringify(pagination))
      })
    },
    paginationChange(pagination) {
      this.pagination = pagination
      this.fetchData()
    },
    onSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
    tableRowClass(record, index) {
      if (index % 2 === 0) {
        return 'row-class-even'
      } else {
        return 'row-class-odd'
      }
    },
    onDelete(id) {
      const ids = [id].join(',')
      this.delete(ids)
    },
    delete(ids = '') {
      deleteCooperation({ ids }).then(() => {
        this.fetchData()
        this.$notification['success']({
          message: '成功',
          description: '删除成功',
          duration: 3
        })
      })
    },
    onDeleteInBatch() {
      const { rowKeys } = this
      if (rowKeys && rowKeys.length > 0) {
        const ids = rowKeys.join(',')
        this.delete(ids)
        this.fetchData()
      }
    },
    formatContent(text, keyword) {
      text = text || ''
      if (typeof text === 'number') {
        text = String(text)
      }
      return text.replace(
        new RegExp(keyword, 'g'),
        `<strong style="color: red;">${keyword}</strong>`
      )
    }
  }
}
</script>

<style></style>
